import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Loader2, CheckCircle2, XCircle, Calendar } from 'lucide-react';
import { BrandLogo } from '../components/BrandLogo';

export default function WaitlistResponse() {
  const { token, action } = useParams();
  const [state, setState] = useState('working');
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.post(`/waitlist/respond/${token}/${action}`)
       .then(r => { setData(r.data); setState('done'); })
       .catch(e => {
         setErr(e?.response?.data?.detail || 'Could not process response');
         setState('error');
       });
  }, [token, action]);

  const isAccept = action === 'accept';

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 bg-surface">
      <div className="w-full max-w-md surface border border-soft rounded-xl shadow p-8 text-center">
        <BrandLogo size={64} className="mx-auto"/>
        {state === 'working' && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-brand mx-auto mt-6"/>
            <p className="text-fg-muted mt-3 text-sm">Processing your response…</p>
          </>
        )}
        {state === 'done' && (
          <>
            {isAccept
              ? <CheckCircle2 className="w-12 h-12 text-brand mx-auto mt-6"/>
              : <XCircle className="w-12 h-12 text-fg-muted mx-auto mt-6"/>}
            <h1 className="text-2xl font-heading font-bold mt-4">
              {isAccept ? 'Slot confirmed!' : 'Offer declined'}
            </h1>
            <p className="text-sm text-fg-muted mt-2">{data?.message}</p>
            {isAccept && data?.appointment_id && (
              <Link to="/patient" className="btn-primary mt-6 inline-flex items-center gap-2">
                <Calendar className="w-4 h-4"/> View my appointments
              </Link>
            )}
            {!isAccept && (
              <Link to="/patient" className="btn-secondary mt-6 inline-block">Back to my account</Link>
            )}
          </>
        )}
        {state === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-[#B83A3A] mx-auto mt-6"/>
            <h1 className="text-2xl font-heading font-bold mt-4">Couldn't process</h1>
            <p className="text-sm text-[#B83A3A] mt-2" data-testid="wl-err">{err}</p>
            <Link to="/login" className="btn-secondary mt-6 inline-block">Sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
